/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum achHeader {
  instructionId = "Instruction ID",
  fundingDate = "Funding Date",
  achDate = "ACH Date",
  ledgerType = "Ledger Type",
  merchantId = "Merchant ID",
  processorMerchantId = "Processor Merchant ID",
  amount = "Amount",
  type = "Type",
  accountType = "Account Type",
  subMerchantName = "Submerchant Name",
  reportGroup = "Report Group",
  response = "Response",
  responseTime = "Response Time",
  message = "Message",
  fundingStatus = "Funding Status",
  achstatus = "ACH Status"
}
